'use client';

import { c as _c } from "react/compiler-runtime";
import './nav-search.scss';
import { useTranslation } from 'react-i18next';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { getPublicConfig } from '@sola/config/lib/getters.ts';
interface NavSearchProps {
  className?: string;
}
export const NavSearch = t0 => {
  const $ = _c(16);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["articles", "common", "priority"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let T0;
  let t2;
  let t3;
  if ($[1] !== className) {
    const {
      NEXT_PUBLIC_BASE_URL_DOTCOM
    } = getPublicConfig();
    T0 = Link;
    t2 = cn("NavSearch flex p-comfy-xs relative", className);
    t3 = new URL("/search", NEXT_PUBLIC_BASE_URL_DOTCOM);
    $[1] = className;
    $[2] = T0;
    $[3] = t2;
    $[4] = t3;
  } else {
    T0 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("articles:search");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("articles:search");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArkIcon iconName="search-sm" className="NavSearch__icon" size="1.5em" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== T0 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t7 = <T0 className={t2} href={t3} title={t4} aria-label={t5}>{t6}</T0>;
    $[10] = T0;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};